import { useSelector } from 'react-redux'

import type { Props } from 'services/content/components/types/ArticleList'
import { getCommentLabelTextString } from 'store/strings/selectors'
import useArticles from 'hooks/useArticles'
import LandingPageArticleList from 'ui-component-library/components/LandingPageArticleList'

function LandingPageArticleListContainer({
  noResultsFoundText,
  loadMoreText,
  ...props
}: Props) {
  const { categories, orderBy, perPage, sort, contentType } = props
  const {
    articles,
    isLoading,
    isLoadingMore,
    onLoadMore,
    hasMore,
  } = useArticles({ categories, orderBy, perPage, sort, contentType })
  const commentLabelText = useSelector(getCommentLabelTextString)

  return (
    <LandingPageArticleList
      commentLabelText={commentLabelText}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      articles={articles}
      noResultsFoundText={noResultsFoundText}
      loadMoreText={loadMoreText}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
    />
  )
}

export default LandingPageArticleListContainer
